import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const caseArticles = articles.filter((a) => a.category === 'cases');

export default function Cases() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              真实用户成功案例
            </h2>
            <p className="text-foreground-500">看看他们如何借助磁力金牛实现财富跨越</p>
          </div>
          <Link
            to="/category/cases"
            className="mt-4 sm:mt-0 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部案例 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {caseArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-3-line text-xl text-accent-600"></i>
                </div>
                <div>
                  <div className="font-heading font-semibold text-foreground-900 text-sm">
                    {article.title.split('：')[0]}
                  </div>
                  <div className="text-xs text-foreground-400">{article.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                {article.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium group-hover:gap-2 transition-all">
                阅读全文 <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}